import React from "react";

import { Button } from "antd";

import { hasPermission, permissions } from "../../utils/Permissions";
import { useAccessStatus } from "../grace-period/hooks/useAccessStatus";

import { ReactComponent as SupplyPickupLandingIllustration } from "../../assets/icons/Supply & Pickup/supply-pickup-landing-page.svg";
import { ReactComponent as BoxIcon } from "../../assets/images/supply-pickup/Box.svg";
import { ReactComponent as ShoppingCartIcon } from "../../assets/images/supply-pickup/ShoppingCart.svg";

import "./SupplyPickupLanding.css";
import "./SupplyPickupTabGroup/SupplyPickupTabGroup.css";

export default function SupplyPickupLanding({
  tab = "supply",
  onCreateSupplyClick,
  onCreatePickupClick,
  createPickupLoading = false,
}) {
  const { areResultsLocked } = useAccessStatus();
  const hasSupplyAccess = hasPermission(permissions.schedules.supplyRequest);
  const hasPickupAccess = hasPermission(permissions.schedules.pickupRequest);

  const getEmptyMessage = () => {
    if (tab === "pickup") {
      return "No Pickup Schedules Available";
    }
    return "No Supply Schedules Available";
  };

  const showSupplyCreate = tab === "supply" && hasSupplyAccess && onCreateSupplyClick && !areResultsLocked;
  const showPickupCreate = tab === "pickup" && hasPickupAccess && onCreatePickupClick && !areResultsLocked;

  return (
    <div className="SupplyPickupMainDiv">
      <div className="SPLandingContent">
        <div className="SPLanding__ImageContainer">
          <SupplyPickupLandingIllustration className="SPLanding__Illustration" />
          <span>{getEmptyMessage()}</span>
        </div>
        {showSupplyCreate && (
          <div className="SPLanding__BtnContainer">
            <Button
              type="default"
              className="SPLanding__Btn"
              onClick={onCreateSupplyClick}
            >
              <span className="SPLanding__BtnIconWrap">
                <ShoppingCartIcon />
              </span>
              Create Supply Request
            </Button>
          </div>
        )}
        {showPickupCreate && (
          <div className="SPLanding__BtnContainer">
            <Button
              type="default"
              className="SPLanding__Btn"
              onClick={onCreatePickupClick}
              loading={createPickupLoading}
              disabled={createPickupLoading}
            >
              <span className="SPLanding__BtnIconWrap">
                <BoxIcon />
              </span>
              Create Pickup Request
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
